import type { FC } from 'react';
import { Grid2, Box, Link, SxProps, Theme } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

interface ILinkProps {
  activeLink: string;
  url: string;
  title: string;
}

interface ILinkTitleProps {
  title: string;
  containerSx?: SxProps<Theme>;
}

export const NavLinkTitle: FC<ILinkTitleProps> = ({ title, containerSx }) => {
  return (
    <Grid2
      container
      size={12}
      sx={{
        borderBottom: '1px solid #cecccb',
        pb: 1,
        pl: 1,
        mb: 1,
        fontWeight: 600,
        fontSize: 20,
        ...containerSx,
      }}
    >
      {title}
    </Grid2>
  );
};

export const NavLink: FC<ILinkProps> = ({ activeLink, url, title }) => {
  const theme = useTheme();

  return (
    <Box
      fontWeight={500}
      fontSize={16}
      sx={{
        py: 1.5,
        pl: 1,
        mb: 1,
        mr: 1,
        borderRadius: 1,
        minWidth: '175px',
        color: activeLink.includes(url)
          ? theme.palette.primary.main
          : theme.palette.text.primary,
        backgroundColor: activeLink.includes(url)
          ? alpha(theme.palette.primary.main, 0.1)
          : 'transparent',
        fontWeight: activeLink.includes(url) ? 600 : 400,
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.1),
        },
        '&:active': {
          backgroundColor: alpha(theme.palette.primary.main, 0.25),
        },
      }}
    >
      <Link
        underline="none"
        component="a"
        href={`${url}`}
        sx={{ display: 'flex', alignItems: 'center', fontSize: 14 }}
        color="#1e2022"
      >
        {title}
      </Link>
    </Box>
  );
};
